"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Levels = exports.Roles = void 0;
const ADMINISTRATOR = "administrator";
const DIRECTOR = "director";
const CONVENOR = "convenor";
const MANAGER = "manager";
const OBSERVER = "observer";
const REGISTRAR = "registrar";
const GUEST = "guest";
const SCHEDULER = "scheduler";
const APP = "app";
const BROADCASTER = "broadcaster";
const Roles = {
    ADMINISTRATOR,
    DIRECTOR,
    CONVENOR,
    MANAGER,
    OBSERVER,
    REGISTRAR,
    GUEST,
    SCHEDULER,
    APP,
    BROADCASTER,
};
exports.Roles = Roles;
const ASSOCIATIONS = "associations";
const LEAGUES = "leagues";
const SEASONS = "seasons";
const DIVISIONS = "divisions";
const TEAMS = "teams";
const LOCATIONS = "locations";
const PROTOTEAMS = "prototeams";
const CLUBS = "clubs";
const Levels = {
    ASSOCIATIONS,
    LEAGUES,
    SEASONS,
    DIVISIONS,
    TEAMS,
    LOCATIONS,
    PROTOTEAMS,
    CLUBS,
};
exports.Levels = Levels;
